export default "/assets/sounds/caller_ring.d40256b3.mp3";